<template>
  <div
    v-if="showLanguageSelector"
    v-outside-click="closeDropdown"
    :class="b()"
  >
    <div
      :class="b('inner')"
      @click="open = !open"
    >
      <div :class="b('content', { inverted: open })">
        {{ (languages.active && languages.active.name) || '-' }}

        <span :class="b('icon', { flipped: open })">
          <e-icon-sprite
            icon="i-chevron-down"
            size="12"
          />
        </span>
      </div>

      <div :class="b('dropdown-anchor')">
        <c-transition-expand>
          <div
            v-show="open"
            @click="closeDropdown"
          >
            <ul :class="b('dropdown', { inverted: open })">
              <li
                v-for="(language, index) in languages.available"
                :key="index"
              >
                <a
                  :class="b('entry')"
                  :href="language.url"
                >
                  {{ language.name }}
                </a>
              </li>
            </ul>
          </div>
        </c-transition-expand>
      </div>
    </div>
  </div>
</template>

<script>
  import useSessionStore from '@/stores/session';
  import cTransitionExpand from '@/components/c-transition-expand.vue';
  import eIconSprite from '@/elements/e-icon-sprite.vue';

  /**
   * Renders a menu to change the page language.
   */
  export default {
    name: 'c-ids-language-menu',

    components: {
      eIconSprite,
      cTransitionExpand,
    },

    // props: { },

    setup() {
      return {
        sessionStore: useSessionStore(),
      };
    },
    data() {
      return {
        /**
         * @type {Boolean} Tracks the state of the dropdown menu.
         */
        open: false,
      };
    },

    computed: {
      /**
       * Returns if the language selector should be shown.
       *
       * @returns {Boolean}
       */
      showLanguageSelector() {
        return this.sessionStore.languages?.length > 1;
      },

      /**
       * Converts languages for use in the template.
       *
       * @returns {Object}
       */
      languages() {
        const languages = this.sessionStore.languages.map(({ isSelected: active, iso, url }) => ({
          url,
          name: (iso.match(/^[a-z]+/)?.[0] || iso).toUpperCase(), // extract language code and convert to upper case
          active,
        }));

        return {
          active: languages.find((language) => language.active),
          available: languages.filter((language) => !language.active),
        };
      },
    },
    // watch: { },
    // beforeCreate() {},
    // created() { },
    // beforeMount() {},
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // activated() {},
    // deactivated() {},
    // beforeUnmount() {},
    // unmounted() { },

    methods: {
      /**
       * Method for various click handlers to close the dropdown menu.
       */
      closeDropdown() {
        this.open = false;
      },
    },
    // render() {},
  };
</script>

<style lang="scss">
  @use 'sass:math';
  @use '@/setup/scss/variables';
  @use '@/setup/scss/mixins';
  @use '@/setup/scss/functions';
  @use '@/setup/scss/extends' as *;

  .c-ids-language-menu {
    $this: &;
    $height: 38px;
    $padding: 10px;
    $border-width: 1px;
    $border-radius: 5px;
    $icon-width: 12px;
    $transition-duration: variables.$transition-duration--200;

    &__inner {
      @include mixins.font-size(variables.$font-size--16);

      position: relative;
      color: variables.$color-primary--1;
      user-select: none;
    }

    &__content,
    &__dropdown {
      border: $border-width solid variables.$color-grayscale--915;
      background-color: variables.$color-grayscale--915;
      transition:
        background-color $transition-duration ease-in-out,
        border-color $transition-duration ease-in-out;

      &--inverted {
        border-color: variables.$color-grayscale--810;
        background-color: variables.$color-grayscale--1000;
      }
    }

    &__content {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      height: functions.rem($height);
      padding: 0 functions.rem($padding);
      border-radius: functions.rem($border-radius);
      cursor: pointer;
    }

    &__dropdown-anchor {
      @include mixins.z-index(languageDropdown);

      position: absolute;
      top: functions.rem($height - $border-radius);
      right: 0;
      left: 0;
    }

    &__dropdown {
      @extend %list-reset;

      position: relative;
      padding-bottom: functions.rem($padding * 0.5);
      border-top: 0;
      border-bottom-right-radius: functions.rem($border-radius);
      border-bottom-left-radius: functions.rem($border-radius);
    }

    &__icon {
      transition: transform $transition-duration ease-in-out;
      pointer-events: none;
      margin-bottom: 2px; // TODO: font fix.

      &--flipped {
        transform: rotateZ(-180deg);
      }
    }

    &__entry {
      display: block;
      padding: functions.rem(($padding * 0.5) $padding);
      color: inherit;
    }
  }
</style>
